<template>
  <div class="form-newsletter-box">
    <div class="form-newsletter-box__title font-bold -upper">
      {{ $t('Join the Zenith community') }}
    </div>
    <p class="form-newsletter-box__description font-normal">
      {{
        $t(
          'Become a part of the ZENITH community to be the first to discover new product unveilings and access exclusive offers'
        )
      }}
    </p>
    <div class="form-newsletter-box__checkbox">
      <base-checkbox
        v-if="!$slots.default || !value"
        id="is_subscribed"
        name="is_subscribed"
        :value="value"
        @change="$emit('change', $event)"
        :required="isRequired"
        :validations="validations"
      >
        <span v-text="isRequired ? $t('Yes, I would like to join') + ' *' : $t('Yes, I would like to join')"></span>
      </base-checkbox>
      <slot v-else />
    </div>
  </div>
</template>

<script>
import BaseCheckbox from './BaseCheckbox.vue'

export default {
  name: 'NewsletterBox',
  components: {
    BaseCheckbox
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    validations: {
      type: Array,
      default: () => []
    },
    isRequired: {
      type: Boolean,
      default: false
    }
  }
}
</script>
